import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const MakeCopy = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M15.8 19.8C15.8 20.44 15.24 21 14.6 21H6.2C5.56 21 5 20.44 5 19.8V9.00005C5 8.36005 5.56 7.80005 6.2 7.80005H12.28C12.6 7.80005 12.92 7.96005 13.16 8.12005L15.48 10.44C15.72 10.68 15.8 11 15.8 11.32V19.8Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.59985 7.8V4.2C8.59985 3.56 9.15985 3 9.79985 3H15.8799C16.1999 3 16.5199 3.16 16.7599 3.32L19.0799 5.64C19.3199 5.88 19.3999 6.2 19.3999 6.52V15C19.3999 15.64 18.8399 16.2 18.1999 16.2H15.7999"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
